import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ServiceDetailsV2 from './service-details-v2/ServiceDetailsV2';
import useResolvedServiceRoute from './hooks/useResolvedServiceRoute';

const ServiceDetailsPage = () => {
  const { serviceId: routeParam } = useParams();
  const navigate = useNavigate();
  const { status, firestoreId } = useResolvedServiceRoute(routeParam);

  if (!routeParam) return null;
  if (status === 'loading' || status === 'idle') return null;
  if (status === 'not_found' || !firestoreId) return null;

  return (
    <ServiceDetailsV2
      serviceId={firestoreId}
      onBack={() =>
        navigate('/app/overview/settings', {
          state: { section: 'services-categories', parent: 'services-categories', servicesTab: 'services' },
        })}
    />
  );
};

export default ServiceDetailsPage;